import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskProactiveSupportDashboardRoute: InvariantJiraRoute = {
	name: 'servicedesk-proactive-support-dashboard',
	path: '/jira/servicedesk/projects/:projectKey/proactive-support/dashboard',
	exact: true,
};
